import React from 'react';
import { Box, Text, Badge, Image, Flex } from '@chakra-ui/react';
import { DocumentItemProps } from '../../types/page';
import SvgIcon from '../ui/icons/SvgIcon';
import { SVGIconType } from '../../types/icons';

export default function DocumentItem({ name, type, extension, url }: DocumentItemProps) {
    const computeExtension = extension.split('.').join('') as SVGIconType;

    function computeIconColor() {
        switch(extension) {
            case '.pdf':
                return '0 0 512 512'
            case '.csv':
                    return '0 0 400 400'
            default:
                return '0 0 36 36'
        }
    }

    return (
        <Box 
            borderWidth="1px" 
            rounded="lg" 
            overflow="hidden" 
            flexBasis={'230px'} 
            height='200px'
            marginBottom={'8'}
            marginRight={'4'}
            justifyContent='space-between'
            display='flex'
            flexDirection='column'
            boxShadow={'0 2px 8px 0 rgba(0, 0, 0, 0.15)'}
        >
            <Flex justifyContent={'center'} alignContent='center' width='full' height='130px' paddingY={'6'}>
                {url ? (
                    <Image src={url} alt={`placeholder image for a ${type}`} />
                ): (
                    <SvgIcon 
                        type={computeExtension}
                        viewBox={computeIconColor()}
                        height='70px'
                        width='100%'
                        color='teal'
                    />
                )}
            </Flex>

            <Flex p="6" alignItems={'center'} justifyContent='center'>
                <Badge 
                    px="2" 
                    fontSize={'xx-small'}
                    color='whiteAlpha.800' 
                    background='teal.500' 
                    textTransform={'uppercase'}
                >
                    {computeExtension}
                </Badge>
                <span>
                    <Text
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        ml="2"
                        textOverflow={'ellipsis'}
                        overflow='hidden'
                        width={'140px'}
                        whiteSpace='nowrap'
                    >
                        {name}
                    </Text>
                </span>
            </Flex>
        </Box>
    )
}